import type { DomainMapper } from '../types';

// TODO: Backend team should create a dedicated applicationId for corporate domains.
// Currently reusing GB's applicationId (1161 stage / 1163 prod) to get translations
// from /applications/configuration. This also returns ecom data (filters, products)
// which we don't need — the dedicated applicationId should only return translations.
const corporateEn: DomainMapper = {
  countryCode: 'corporate-en',
  currency: 'GBP',
  domain: 'www.kahrsgroup.com',
  environment: 'production',
  flagUrl: '/flags/GB-UKM.svg',
  languagePrimary: false,
  locale: 'en-GB',
  logoUrl: 'kahrs-logo',
  noRobots: false,
  sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-en.xml',
  storyblokBasePath: 'en',
  url: 'https://www.kahrsgroup.com/en',
  applicationId: 1163, //  reusing GB until dedicated corporate applicationId exists
  subFolder: true,
  googleSiteVerification: ['_khK6fTW4MrMqgixPOHH37F9BD7VJNkk3JXdFUMZthA', '9sVFrFRN6d5-0JEBT5fFb7mliMyxDooAit1km1jMxdA'],
  bodyClass: 'corpSite',

  features: {
    fastOrder: false,
    backorders: false,
    cartSettings: false,
    nonEcomSite: true,
    cisionLanguage: 'en',
  },
} as DomainMapper;

export default corporateEn;
